import React from "react";
import "../static/bodyDescription.css";
import "../static/middleBody.css";
import chroma from "../static/images/chroma.png";
import help from "../static/images/help.png";
import network from "../static/images/network.png";
import connect from "../static/images/connect.png";
import ombreForBrands from "../static/images/ombreForBrands.gif";
import ombreForBrandsMobile from "../static/images/ombreForBrandsMobile1.gif";

function MiddleBody() {
  return (
    <div className="middleBody">
      <div className="conductEventsTitle successEventTitle text-center  m-auto d-none d-xl-block d-lg-block d-md-block d-sm-none d-none">
        Everything you need to Organise a Successful Virtual Event
      </div>
      <div className="conductEventsTitle successEventTitleMobile text-center  m-auto d-none d-xl-none d-lg-none d-md-none d-sm-block d-block col-sm-10 col-10">
        Organise a Successful Virtual Event
      </div>
      <div className="upperbodyContainer">
        <div className="container-fluid">
          <div className="row">
            <div className="mb-sm-5 mb-5 col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start mx-sm-auto mx-auto  order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
              <div className="row flex-column align-items-center justify-content-center">
                <img
                  className="upperbodyImage pb-xl-3 pb-lg-3 pb-md-3"
                  src={chroma}
                />
                <div className="curatedHeading artistCuratedHeading  middleBodyGridHeading text-center col-sm-12  col-12 ">
                  Virtual Green Screen
                </div>
                <div className="curatedDescription artistCuratedDescription text-center col-xl-9 col-lg-9 col-md-9 col-sm-10 col-10 p-0">
                  We provide you with virtual stage setup to make your show
                  stand out !
                </div>
              </div>
            </div>

            <div className="mb-sm-5 mb-5 col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start mx-sm-auto mx-auto order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
              <div className="row flex-column align-items-center justify-content-center">
                <img
                  className="upperbodyImage pb-xl-3 pb-lg-3 pb-md-3"
                  src={help}
                />

                <div className="curatedHeading text-center artistCuratedHeading middleBodyGridHeading text-center col-xl-10 col-lg-10 col-md-10  col-sm-12 col-12 ">
                  {"Marketing & Design Support"}
                </div>
                <div className="curatedDescription artistCuratedDescription text-center col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 p-0">
                  World class design and marketing support across social media
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="containerFluid margin-top-10">
          <div className="row ">
            <div className="mb-sm-5 mb-5 col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start mx-sm-auto mx-auto order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
              <div className="row flex-column align-items-center justify-content-center">
                <img
                  className="upperbodyImage pb-xl-3 pb-lg-3 pb-md-3"
                  src={network}
                />

                <div className="curatedHeading text-center artistCuratedHeading middleBodyGridHeading text-center col-xl-12 col-lg-12 col-md-12  col-sm-10  col-10 ">
                  Multiple Hosting
                </div>
                <div className="curatedDescription artistCuratedDescription text-center col-xl-9 col-lg-9 col-md-9 col-sm-8 col-8 p-0">
                  Host your event across youtube, instagram, and more at the
                  same time
                </div>
              </div>
            </div>

            <div className="mb-sm-4 mb-4 col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start mx-sm-auto mx-auto order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
              <div className="row flex-column align-items-center justify-content-center">
                <img
                  className="upperbodyImage pb-xl-3 pb-lg-3 pb-md-3"
                  src={connect}
                />

                <div className="curatedHeading text-center artistCuratedHeading middleBodyGridHeading text-center col-xl-12 col-lg-12 col-md-12  col-sm-10  col-10 ">
                  Artist Connect
                </div>
                <div className="curatedDescription artistCuratedDescription text-center col-xl-9 col-lg-9 col-md-9 col-sm-8 col-8 p-0">
                  A large catalog of Artistready to perform at your fest
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="containerFluid mt-5 ombreBrandsContainer overflow-hidden">
        <div className="row">
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 text-xl-start text-lg-start text-md-start  m-xl-auto m-lg-auto m-md-auto  mx-sm-auto  mt-sm-5  mx-auto mt-5 order-xl-2 order-lg-2 order-md-2  order-sm-2 order-2 p-0">
            <div className="curatedHeading artistsCuratedHeading col-xl-12 col-md-12 col-lg-12 col-sm-6 col-6 p-0 mx-auto">
              Ombré for Brands
            </div>
            <div className="curatedDescription  col-xl-12 col-md-12 col-lg-12 col-sm-10 col-10 mb-sm-4 mb-4 p-0 mx-auto">
              Ombré fills rooms with fans ! Brands can advertise by sponsoring
              events. We have 1000+ influencers to promote you !
            </div>
          </div>
          <div className="d-none d-xl-block d-lg-block d-md-block d-sm-none d-none col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mx-auto curatedContainer order-xl-2 order-lg-2 order-md-2  order-sm-1 order-1 ">
            <img className="ombreForBrandsImage" src={ombreForBrands} />
          </div>
          <div className=" d-none d-xl-none d-lg-none d-md-none d-sm-block d-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mx-auto curatedContainer order-xl-2 order-lg-2 order-md-2  order-sm-1 order-1 ">
            <img className="ombreForBrandsImage" src={ombreForBrandsMobile} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MiddleBody;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/components/MiddleBody.jsx